import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../style/Services.css";
import "../style/homepage.css";
import Footer from "../components/Footer";
import Header from "../components/Header";

const Services = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <main className="services-page">
      <Header />

      <section className="services-hero">
        <div className="services-hero-content">
          <span className="services-eyebrow">
            {t("services.heroEyebrow")}
          </span>

          <h1>{t("services.heroTitle")}</h1>

          <p>{t("services.heroText")}</p>

          <div className="services-actions">
            <button
              type="button"
              className="services-primary-btn"
              onClick={() => navigate("/contact")}
            >
              {t("services.bookConsultation")}
            </button>

            <button
              type="button"
              className="services-secondary-btn"
              onClick={() => navigate("/services")}
            >
              {t("services.viewServices")}
            </button>
          </div>
        </div>
      </section>

      <section className="services-intro">
        <span className="services-eyebrow dark">
          {t("services.offerEyebrow")}
        </span>

        <h2>{t("services.offerTitle")}</h2>

        <p>{t("services.offerText")}</p>
      </section>

      <section className="services-grid">
        {t("services.cards", { returnObjects: true }).map((item) => (
          <div
            className={`service-card ${item.dark ? "dark-card" : ""}`}
            key={item.number}
          >
            <span>{item.number}</span>

            <h3>{item.title}</h3>

            <p>{item.text}</p>
          </div>
        ))}
      </section>

      <section className="how-section">
        <div className="how-header">
          <span className="services-eyebrow">
            {t("services.processEyebrow")}
          </span>

          <h2>{t("services.processTitle")}</h2>

          <p>{t("services.processText")}</p>
        </div>

        <div className="process-line"></div>

        <div className="process-grid">
          {t("services.steps", { returnObjects: true }).map((step) => (
            <div className="process-step" key={step.number}>
              <div className="step-circle">{step.number}</div>

              <h3>{step.title}</h3>

              <p>{step.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="services-feature">
        <div className="feature-image">
          <img
            src="https://images.unsplash.com/photo-1542362567-b07e54358753?auto=format&fit=crop&w=1200&q=80"
            alt={t("services.featureImageAlt")}
          />
        </div>

        <div className="feature-content">
          <span className="services-eyebrow dark">
            {t("services.privateEyebrow")}
          </span>

          <h2>{t("services.privateTitle")}</h2>

          <p>{t("services.privateText")}</p>

          <button
            type="button"
            className="services-primary-btn"
            onClick={() => navigate("/contact")}
          >
            {t("services.startJourney")}
          </button>
        </div>
      </section>

      <section className="services-cta">
        <span className="services-eyebrow">
          {t("services.ctaEyebrow")}
        </span>

        <h2>{t("services.ctaTitle")}</h2>

        <p>{t("services.ctaText")}</p>

        <button
          type="button"
          className="services-primary-btn"
          onClick={() => navigate("/contact")}
        >
          {t("services.scheduleAppointment")}
        </button>
      </section>

      <Footer />
    </main>
  );
};

export default Services;